import { useGlobals } from "@/components/providers/globals-provider.tsx";
import { type EventMap, type GlobalEventFields, trackEvent } from "../lib/tracking.ts";

export default function useTracking() {
    const { site, locale } = useGlobals();

    return <E extends keyof EventMap>(event: E, data: Omit<EventMap[E], GlobalEventFields>) => {
        (trackEvent as (event: E, data: EventMap[E]) => void)(event, { ...data, locale, site } as EventMap[E]);
    };
}
